import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const LegendContainer = styled.div`
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
	margin-top: 32px;
`;

export const LegendItem = styled.div`
	display: flex;
	align-items: center;
	margin: 0 8px 14px 8px;
`;

export const BarLegendItem = styled(LegendItem)`
	margin: 0 16px 14px 16px;
`;

export const LegendBarIcon = styled.div`
	height: 16px;
	width: 16px;
	position: relative;
`;

export const LegendText = styled.div`
	margin-left: 8px;
	font-size: 11px;
	color: ${colors.grey6};
`;
